import { createStoreModule } from '../utils';
export default createStoreModule({
  name: 'file',
  modelName: 'files',
  crud: true,
  endpoint: {}
});
